import { useCallback, useEffect } from 'react';

// Global event emitter for countdown reset
class CountdownResetEmitter {
    private listeners: Set<() => void> = new Set();

    subscribe(callback: () => void) {
        this.listeners.add(callback);
        return () => this.listeners.delete(callback);
    }

    emit() {
        this.listeners.forEach((callback) => callback());
    }
}

const countdownResetEmitter = new CountdownResetEmitter();

export function useGlobalCountdownReset() {
    const resetCountdown = useCallback(() => {
        countdownResetEmitter.emit();
    }, []);

    return { resetCountdown };
}

export function useCountdownResetListener(resetCallback: () => void) {
    useEffect(() => {
        const unsubscribe = countdownResetEmitter.subscribe(resetCallback);
        return () => {
            unsubscribe();
        };
    }, [resetCallback]);
}
